function setupMenuScroll() {
    function checkMenuWidth() {
        const menuComponent2 = document.querySelector(".list-menu--inline"),
            menuContainer = document.querySelector(".header__inline-menu");
        menuComponent2.scrollWidth > menuContainer.offsetWidth
            ? menuContainer.classList.add("menu-overflow")
            : menuContainer.classList.remove("menu-overflow");
    }
    function checkScroll() {
        const menuComponent2 = document.querySelector(".list-menu--inline"),
            leftArrow2 = document.querySelector(".menu-slide-arrow-left"),
            rightArrow2 = document.querySelector(".menu-slide-arrow-right"),
            scrollLeft = menuComponent2.scrollLeft,
            scrollWidth = menuComponent2.scrollWidth,
            clientWidth = menuComponent2.clientWidth;
        scrollLeft <= 0 ? leftArrow2.setAttribute("disabled", "") : leftArrow2.removeAttribute("disabled"),
            scrollLeft + clientWidth + 2 >= scrollWidth
                ? rightArrow2.setAttribute("disabled", "")
                : rightArrow2.removeAttribute("disabled");
    }
    checkMenuWidth(), window.addEventListener("resize", checkMenuWidth);
    const menuComponent = document.querySelector(".list-menu--inline"),
        leftArrow = document.querySelector(".menu-slide-arrow-left"),
        rightArrow = document.querySelector(".menu-slide-arrow-right");
    leftArrow.addEventListener("click", () => {
        menuComponent.scrollBy({ left: -200, behavior: "smooth" }), setTimeout(checkScroll, 300);
    }),
        rightArrow.addEventListener("click", () => {
            menuComponent.scrollBy({ left: 200, behavior: "smooth" }), setTimeout(checkScroll, 300);
        }),
        menuComponent.addEventListener("scroll", checkScroll),
        checkScroll();
}
setupMenuScroll();